import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Box from '@amzn/meridian/box';
import Button from '@amzn/meridian/button';
import Divider from '@amzn/meridian/divider';
import Row from '@amzn/meridian/row';
import { setIsCancelModalOpen, setPageProgress } from 'src/store/newJmrPageSlice';
import { JmrPageProgress } from 'src/utils/jmrUtils';
import { useAppSelector } from 'src/store/store';
import { NewJMRPageMainBody, NewJMRPageWrapper, NewJMRPageFooter } from '../pageLayout/pageLayout';
import BackgroundReview from './backgroundReview/backgroundReview';
import RestrictionsReview from './restrictionsReview/restrictionsReview';
import PlacementSelectionsReview from './placementSelectionsReview/placementSelectionsReview';
import BackgroundReviewLegacy from './backgroundReview/backgroundReviewLegacy';
import RestrictionsReviewLegacy from './restrictionsReview/restrictionsReviewLegacy';
import PlacementSelectionsReviewLegacy from './placementSelectionsReview/placementSelectionsReviewLegacy';

/**
 * Default component
 */
const ReviewPage = () => {
  const dispatch = useDispatch();
  const { featureFlags } = useAppSelector((state) => state.user);
  const { allowedSites } = useAppSelector((state) => state.sites);
  const { backgroundFormData } = useAppSelector((state) => state.newJmrPage);

  // Check criteria to determine whether to use the new experience
  const isUsingJobModificationsExperience = useMemo(
    () =>
      featureFlags.JOB_MODIFICATIONS &&
      allowedSites.some((site) => site.site === backgroundFormData.siteLocation && site.jobModificationsEnabled),
    [featureFlags.JOB_MODIFICATIONS, allowedSites],
  );

  return (
    <NewJMRPageWrapper>
      {/* Main Body */}
      <NewJMRPageMainBody sm="90%" md="75%" lg="50%" title="Review Job Match">
        {isUsingJobModificationsExperience ? (
          <>
            <Box spacingInset="400" />
            <BackgroundReview />
            <Box spacingInset="400" />
            <RestrictionsReview />
            <Box spacingInset="400" />
            <PlacementSelectionsReview />
          </>
        ) : (
          <>
            <Divider spacingBefore="500" spacingAfter="300" />
            <BackgroundReviewLegacy />
            <Divider spacingBefore="500" spacingAfter="100" />
            <RestrictionsReviewLegacy />
            <Divider spacingBefore="500" spacingAfter="100" />
            <PlacementSelectionsReviewLegacy />
          </>
        )}
      </NewJMRPageMainBody>

      {/* Footer */}
      <NewJMRPageFooter>
        <Row spacing="400">
          <div></div>
          <Button type="link" onClick={() => dispatch(setIsCancelModalOpen(true))}>
            Cancel
          </Button>
          <Button type="tertiary" onClick={() => dispatch(setPageProgress(JmrPageProgress.JobMatches))}>
            Previous
          </Button>
          <Button
            data-cy="new-jmr__review__next"
            onClick={() => dispatch(setPageProgress(JmrPageProgress.SendForApproval))}
          >
            Next
          </Button>
        </Row>
      </NewJMRPageFooter>
    </NewJMRPageWrapper>
  );
};

export default ReviewPage;
